import axios from 'axios';
import { API_URL } from '../config'; 


export default async (image : File, token: string) => {
  let data = new FormData();
  data.append('file', image);

  const { data: { results : { fileUrl }}} = await axios({
    method: 'POST',
    url: `${API_URL}/upload/slide/pic`,
    data,
    headers: {
      Authorization: token
    }
  });
  return fileUrl;
}